import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { GenericModal } from "@Shared/components/modals";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import MissingDetailsStep from "@Broker/@Modules/clients/applications/application/applications-list/components/import-clients/steps/missing-details-step.vue";
import VerifyEmailStep from "@Broker/@Modules/clients/applications/application/applications-list/components/import-clients/steps/verify-email-step.vue";
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import { UPDATE_FILOGIX_DETAILS, LOAD_EXPERT_DETAILS, LOAD_FILOGIX_DETAILS, VERIFY_EXPERT_PROFILE_NUMBER } from "@Broker/@Modules/settings/store/settings-actions";
import { showToast } from "@Shared/@Utils/constants";
import Amplitude from "@Shared/@Utils/amplitude";
import InformationFromExpert from "@Broker/@Modules/settings/account/components/information-from-expert";
import { UPDATE_ACCOUNT_PERSONAL_DETAILS } from "@Broker/@Modules/main/store/account/account-actions";
import ImportFromExpertModalLoader from "./import-from-expert-modal-loader";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ImportFromExpertModal",
  components: {
    GenericModal,
    SimpleButton,
    MissingDetailsStep,
    InformationFromExpert,
    ImportFromExpertModalLoader,
    VerifyEmailStep
  },
  mixins: [validationMixin],
  props: {
    filogixDetails: {
      type: Object,
      required: true
    }
  },
  validations() {
    return {
      filogixDetailsLocal: {
        expertProfileNumber: {
          required
        }
      },
      emailVerificationCode: {
        required: requiredIf(function () {
          return this.confirmPullingInfo && !this.missingFilogixDetailsForImport && !this.invalidExpertProfileNumber && !this.isExpertNumberVerified;
        })
      }
    };
  },
  data() {
    return {
      loading: false,
      loadingSucceeded: true,
      showLoader: false,
      filogixDetailsLocal: {},
      confirmPullingInfo: false,
      isExpertNumberVerified: false,
      invalidExpertProfileNumber: false,
      emailVerificationCode: "",
      verificationEmail: ""
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("SettingsStore", {
    filogixData(state) {
      return state.filogixDetails;
    }
  })), {}, {
    missingFilogixDetailsForImport() {
      return !this.filogixData["expertProfileNumber"];
    },
    btnText() {
      if (this.missingFilogixDetailsForImport || this.invalidExpertProfileNumber) {
        return this.$t("global.words.submit");
      }
      if (this.filogixDetails.hasImportCode || this.confirmPullingInfo && !this.isExpertNumberVerified) {
        return this.$t("settings.accountTab.verifyImportButtonText");
      }
      return this.$t("global.words.sync");
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("SettingsStore", [LOAD_FILOGIX_DETAILS, UPDATE_FILOGIX_DETAILS, LOAD_EXPERT_DETAILS, VERIFY_EXPERT_PROFILE_NUMBER])), mapActions("AccountStore", [UPDATE_ACCOUNT_PERSONAL_DETAILS])), {}, {
    handleShow() {
      this.filogixDetailsLocal = this.filogixDetails;
      this.invalidExpertProfileNumber = false;
      if (this.missingFilogixDetailsForImport) this.confirmPullingInfo = true;
    },
    handleHide() {
      this.confirmPullingInfo = false;
    },
    async handleImport() {
      this.loading = true;
      try {
        if (this.missingFilogixDetailsForImport || this.invalidExpertProfileNumber) {
          await this.updateFilogixDetails();
        }
        if (!this.isExpertNumberVerified && this.emailVerificationCode) {
          await this.verifyExpertProfileNumber();
        }
        await this.loadFilogixDetails();
        if (this.isExpertNumberVerified) {
          this.notifyImportSuccess();
        }
        await this.LOAD_FILOGIX_DETAILS();
        this.loadingSucceeded = true;
      } catch (e) {
        this.loadingSucceeded = false;
        Amplitude.logHandledError(e);
      } finally {
        this.loading = false;
        this.confirmPullingInfo = true;
      }
    },
    async updateFilogixDetails() {
      await this.UPDATE_FILOGIX_DETAILS(this.filogixDetailsLocal);
    },
    async verifyExpertProfileNumber() {
      this.isExpertNumberVerified = await this.VERIFY_EXPERT_PROFILE_NUMBER(this.emailVerificationCode);
      this.emailVerificationCode = "";
    },
    async loadFilogixDetails() {
      this.showLoader = true;
      try {
        const details = await this.LOAD_EXPERT_DETAILS();
        this.isExpertNumberVerified = !(details != null && details.shouldVerify);
        this.verificationEmail = details == null ? void 0 : details.emailFromExpert;
        this.invalidExpertProfileNumber = false;
        await this.updateWithExpertInfo(details);
      } catch (e) {
        this.invalidExpertProfileNumber = true;
        Amplitude.logHandledError(e);
      } finally {
        this.showLoader = false;
      }
    },
    async updateWithExpertInfo(details) {
      if (this.isExpertNumberVerified) {
        this.$emit("update");
        await this.UPDATE_ACCOUNT_PERSONAL_DETAILS({
          details
        });
      }
    },
    notifyImportSuccess() {
      showToast("success", "importHasBegunMessage");
      this.$hideModal();
    },
    filogixDetailsChange(value) {
      this.filogixDetailsLocal = value;
      this.$emit("updateExpertProfileNumber", value);
    },
    updateEmailVerificationCode(value) {
      this.emailVerificationCode = value;
    }
  })
});